// Product page accordion script

// Wait for DOM to be fully ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initProductPage);
} else {
  initProductPage();
}

function initProductPage() {
  console.log('=== INITIALIZING PRODUCT PAGE ===');

  // Initialize accordion
  initAccordion();

  // Initialize quantity selector
  initQuantitySelector();

  // Initialize product gallery
  initProductGallery();

  // Initialize recommendations
  initRecommendations();

  // Initialize fixed bar
  initFixedBar();

  // Initialize variant selector
  initVariantSelector();

  // Initialize share button
  initShareButton();
}

function initAccordion() {
  console.log('=== INITIALIZING ACCORDION ===');

  AccordionManager.init({
    containerSelector: '.product__accordion',
    toggleSelector: '[data-accordion-toggle]',
    itemSelector: '.product__accordion-item',
    activeClass: 'product__accordion-item--active',
    singleOpen: false, // Product accordion allows multiple items open
    ariaSupport: false,
    onToggle: function(item, isOpen, context) {
      // Update the icon
      var svg = context.toggle.querySelector('svg');
      if (svg) {
        if (isOpen) {
          // Opening - show x icon
          svg.innerHTML = '<line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>';
        } else {
          // Closing - show + icon
          svg.innerHTML = '<line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/>';
        }
      }
    }
  });

  console.log('=== ACCORDION INITIALIZED ===');
}

function initQuantitySelector() {
  var quantityInput = document.querySelector('[data-quantity-input]');
  var quantityMinus = document.querySelector('[data-quantity-minus]');
  var quantityPlus = document.querySelector('[data-quantity-plus]');
  var quantityHidden = document.querySelector('[data-quantity-hidden]');
  var buyNowBtn = document.querySelector('[data-buy-now]');

  if (!quantityInput) return;

  var updateQuantity = function(newValue) {
    var value = Math.max(1, parseInt(newValue) || 1);
    quantityInput.value = value;
    if (quantityHidden) quantityHidden.value = value;
    if (buyNowBtn) {
      var href = buyNowBtn.getAttribute('href');
      var newHref = href.replace(/quantity]=\d+/, 'quantity]=' + value);
      buyNowBtn.setAttribute('href', newHref);
    }
  };

  if (quantityMinus) {
    quantityMinus.addEventListener('click', function() {
      updateQuantity(parseInt(quantityInput.value) - 1);
    });
  }

  if (quantityPlus) {
    quantityPlus.addEventListener('click', function() {
      updateQuantity(parseInt(quantityInput.value) + 1);
    });
  }

  quantityInput.addEventListener('change', function() {
    updateQuantity(this.value);
  });
}

function initProductGallery() {
  var galleryMain = document.querySelector('[data-gallery-main]');
  var galleryTrack = document.querySelector('[data-gallery-track]');
  var thumbnails = document.querySelectorAll('[data-thumb]');
  var prevBtn = document.querySelector('[data-gallery-prev]');
  var nextBtn = document.querySelector('[data-gallery-next]');

  if (!galleryTrack) return;

  var slides = galleryTrack.querySelectorAll('.product__gallery-slide');
  var currentIndex = 0;

  // Hide nav buttons if only one image
  if (slides.length <= 1) {
    if (prevBtn) prevBtn.style.display = 'none';
    if (nextBtn) nextBtn.style.display = 'none';
  }

  function goToSlide(index) {
    // Infinite scroll: wrap around on boundaries
    if (index < 0) index = slides.length - 1;
    if (index >= slides.length) index = 0;
    currentIndex = index;

    // Calculate offset in pixels to account for margins
    var slideWidth = galleryMain.offsetWidth;
    var marginRight = 12; // Must match CSS margin-right
    var offset = -index * (slideWidth + marginRight);

    galleryTrack.style.transform = 'translateX(' + offset + 'px)';

    thumbnails.forEach(function(thumb, i) {
      if (i === index) {
        thumb.classList.add('is-active');
      } else {
        thumb.classList.remove('is-active');
      }
    });
  }

  thumbnails.forEach(function(thumb, index) {
    thumb.addEventListener('click', function() {
      goToSlide(index);
    });
  });

  if (prevBtn) {
    prevBtn.addEventListener('click', function() {
      goToSlide(currentIndex - 1);
    });
  }

  if (nextBtn) {
    nextBtn.addEventListener('click', function() {
      goToSlide(currentIndex + 1);
    });
  }

  window.addEventListener('resize', function() {
    goToSlide(currentIndex);
  });
}

function initRecommendations() {
  var recommendationsContainer = document.querySelector('[data-recommendations-grid]');
  var productRecommendations = document.querySelector('.product-recommendations');

  if (!recommendationsContainer || !productRecommendations) return;

  var productId = productRecommendations.dataset.productId;

  fetch('/recommendations/products.json?product_id=' + productId + '&limit=5')
    .then(function(response) { return response.json(); })
    .then(function(data) {
      if (data.products && data.products.length > 0) {
        recommendationsContainer.innerHTML = '';
        data.products.forEach(function(product) {
          var itemWrapper = document.createElement('div');
          itemWrapper.className = 'featured-collection__item';

          var card = createProductCard(product);
          itemWrapper.appendChild(card);
          recommendationsContainer.appendChild(itemWrapper);
        });
        productRecommendations.style.display = 'block';
      }
    })
    .catch(function(error) {
      // console.error('Error loading recommendations:', error);
    });
}

function createProductCard(product) {
  var card = document.createElement('div');
  card.className = 'product-card';

  // Product Image Wrapper
  var imageWrapper = document.createElement('div');
  imageWrapper.className = 'product-card__image-wrapper';

  var imageLink = document.createElement('a');
  imageLink.href = product.url;
  imageLink.className = 'product-card__image-link';

  var img = document.createElement('img');
  img.src = product.featured_image;
  img.alt = product.title;
  img.className = 'product-card__image';
  img.loading = 'lazy';
  img.width = 300;
  img.height = 300;

  imageLink.appendChild(img);
  imageWrapper.appendChild(imageLink);

  // Product Content
  var content = document.createElement('div');
  content.className = 'product-card__content';

  var title = document.createElement('h3');
  title.className = 'product-card__title';

  var titleLink = document.createElement('a');
  titleLink.href = product.url;
  titleLink.textContent = product.title;
  title.appendChild(titleLink);

  // Price Row
  var priceRow = document.createElement('div');
  priceRow.className = 'product-card__price-row';

  var priceDiv = document.createElement('div');
  priceDiv.className = 'product-card__price';

  if (product.compare_at_price && product.compare_at_price > product.price) {
    var discount = Math.round(((product.compare_at_price - product.price) / product.compare_at_price) * 100);

    var salePrice = document.createElement('span');
    salePrice.className = 'product-card__price-sale';
    salePrice.textContent = formatMoney(product.price);

    var comparePrice = document.createElement('span');
    comparePrice.className = 'product-card__price-compare';
    comparePrice.textContent = formatMoney(product.compare_at_price);

    var discountBadge = document.createElement('span');
    discountBadge.className = 'product-card__discount';
    discountBadge.textContent = '-' + discount + '%';

    priceDiv.appendChild(salePrice);
    priceDiv.appendChild(comparePrice);
    priceDiv.appendChild(discountBadge);
  } else {
    var currentPrice = document.createElement('span');
    currentPrice.className = 'product-card__price-current';
    currentPrice.textContent = formatMoney(product.price);
    priceDiv.appendChild(currentPrice);
  }

  // Add to Cart Button
  var addToCartLink = document.createElement('a');
  addToCartLink.href = product.url;
  addToCartLink.className = 'product-card__add-to-cart';
  addToCartLink.textContent = product.available ? 'Add to Cart' : 'Sold Out';
  if (!product.available) {
    addToCartLink.setAttribute('disabled', 'disabled');
  }

  var actionsDiv = document.createElement('div');
  actionsDiv.className = 'product-card__actions';
  actionsDiv.appendChild(addToCartLink);

  priceRow.appendChild(priceDiv);

  content.appendChild(title);
  content.appendChild(priceRow);
  content.appendChild(actionsDiv);

  card.appendChild(imageWrapper);
  card.appendChild(content);

  return card;
}

function formatMoney(cents) {
  return '₹' + Math.round(cents / 100).toLocaleString('en-IN');
}

function initFixedBar() {
  var fixedBar = document.querySelector('.product__fixed-bar');
  var buyButtons = document.querySelector('[data-buttons-row]');

  if (!fixedBar || !buyButtons) return;

  window.addEventListener('scroll', function() {
    var rect = buyButtons.getBoundingClientRect();
    var buttonsOutOfView = rect.bottom < 0;

    if (buttonsOutOfView) {
      fixedBar.classList.add('is-visible');
    } else {
      fixedBar.classList.remove('is-visible');
    }
  });
}

function initVariantSelector() {
  var form = document.querySelector('[data-product-form]');
  if (!form) return;

  var productData = window.productVariants;
  if (!productData) {
    console.log('Product variant data not found');
    return;
  }

  var variantIdInput = document.querySelector('[data-variant-id]');
  var addToCartBtn = document.querySelector('[data-add-to-cart]');
  // Markup uses data-cart-buy-now; the old '[data-buy-now]' selector never
  // matched, so Buy Now kept the first variant's id. Query all of them so the
  // inline button and the mobile sticky bar stay in sync.
  var buyNowBtns = document.querySelectorAll('[data-cart-buy-now]');
  var dynamicCheckout = document.querySelector('.product__dynamic-checkout');
  var quantityInput = document.querySelector('[data-quantity-input]');
  var quantityMinus = document.querySelector('[data-quantity-minus]');
  var quantityPlus = document.querySelector('[data-quantity-plus]');
  var stockIndicator = document.querySelector('[data-stock-indicator]');
  var stockText = document.querySelector('[data-stock-text]');
  var priceWrapper = document.querySelector('.product__price-wrapper');

  // Get all option buttons and selects
  var optionButtons = document.querySelectorAll('[data-option-btn]');
  var optionSelects = document.querySelectorAll('[data-option-select]');

  function updateVariant(variant) {
    if (!variant) return;

    // Update hidden variant ID input
    if (variantIdInput) {
      variantIdInput.value = variant.id;
    }

    // Update add to cart button
    if (addToCartBtn) {
      if (variant.available) {
        addToCartBtn.disabled = false;
        addToCartBtn.textContent = 'Add to Cart';
      } else {
        addToCartBtn.disabled = true;
        addToCartBtn.textContent = 'Sold Out';
      }
    }

    // Update buy now buttons
    buyNowBtns.forEach(function(btn) {
      if (variant.available) {
        btn.style.display = '';
        btn.dataset.variantId = variant.id;
      } else {
        btn.style.display = 'none';
      }
    });

    // Update dynamic checkout button
    if (dynamicCheckout) {
      if (variant.available) {
        dynamicCheckout.style.display = '';
      } else {
        dynamicCheckout.style.display = 'none';
      }
    }

    // Update quantity selector
    if (quantityInput) {
      quantityInput.disabled = !variant.available;
    }
    if (quantityMinus) {
      quantityMinus.disabled = !variant.available;
    }
    if (quantityPlus) {
      quantityPlus.disabled = !variant.available;
    }

    // Update stock indicator
    if (stockIndicator && stockText) {
      var inventory = variant.inventory_quantity;
      var inventoryManaged = variant.inventory_management;
      var stockTemplate = stockIndicator.getAttribute('data-stock-template') || '⏰⏰ Last {quantity} Units Left ⏰⏰';
      var stockThreshold = parseInt(stockIndicator.getAttribute('data-stock-threshold')) || 100;

      if (inventoryManaged && inventory > 0 && inventory < stockThreshold) {
        stockIndicator.style.display = 'flex';
        // Replace {quantity} placeholder with actual inventory
        var displayText = stockTemplate.replace('{quantity}', inventory);
        stockText.textContent = displayText;
      } else {
        stockIndicator.style.display = 'none';
      }
    }

    // Update price
    if (priceWrapper) {
      var price = variant.price;
      var compareAtPrice = variant.compare_at_price;
      var hasDiscount = compareAtPrice && compareAtPrice > price;

      var priceHTML = '';

      if (hasDiscount) {
        var salePrice = formatMoney(price);
        var comparePrice = formatMoney(compareAtPrice);
        var discount = Math.round(((compareAtPrice - price) / compareAtPrice) * 100);

        priceHTML =
          '<span class="product__price product__price--sale">' + salePrice + '</span>' +
          '<span class="product__price product__price--compare">' + comparePrice + '</span>' +
          '<span class="product__badge product__badge--sale">' + discount + '% OFF</span>';
      } else {
        var currentPrice = formatMoney(price);
        priceHTML = '<span class="product__price">' + currentPrice + '</span>';
      }

      priceWrapper.innerHTML = priceHTML;
    }

    // The fixed bar renders its price server-side from product.price, so it
    // goes stale on variant change. Keep it in step with the main price block.
    var barPrice = document.querySelector('.product__fixed-bar-price-current');
    if (barPrice) barPrice.textContent = formatMoney(variant.price);

    var barCompare = document.querySelector('.product__fixed-bar-price-compare');
    var barDiscount = document.querySelector('.product__fixed-bar-discount');
    var barHasDiscount = variant.compare_at_price && variant.compare_at_price > variant.price;

    if (barCompare) {
      barCompare.textContent = barHasDiscount ? formatMoney(variant.compare_at_price) : '';
      barCompare.style.display = barHasDiscount ? '' : 'none';
    }
    if (barDiscount) {
      if (barHasDiscount) {
        var barOff = Math.round(((variant.compare_at_price - variant.price) / variant.compare_at_price) * 100);
        barDiscount.textContent = barOff + '% OFF';
        barDiscount.style.display = '';
      } else {
        barDiscount.style.display = 'none';
      }
    }
  }

  function getSelectedOptions() {
    var selectedOptions = {};

    // Get values from buttons
    optionButtons.forEach(function(btn) {
      if (btn.classList.contains('is-active')) {
        var position = btn.dataset.optionBtn;
        selectedOptions['option' + position] = btn.dataset.value;
      }
    });

    // Get values from selects
    optionSelects.forEach(function(select, index) {
      selectedOptions['option' + (index + 1)] = select.value;
    });

    return selectedOptions;
  }

  function findMatchingVariant(selectedOptions) {
    if (!productData.variants) return null;

    return productData.variants.find(function(variant) {
      return variant.option1 === selectedOptions.option1 &&
             (!variant.option2 || variant.option2 === selectedOptions.option2) &&
             (!variant.option3 || variant.option3 === selectedOptions.option3);
    });
  }

  // Handle option button clicks
  optionButtons.forEach(function(btn) {
    btn.addEventListener('click', function() {
      // Allow sold-out variants to be selected
      // if (this.classList.contains('is-disabled')) return;

      var position = this.dataset.optionBtn;
      var value = this.dataset.value;

      // Update active state
      document.querySelectorAll('[data-option-btn="' + position + '"]').forEach(function(b) {
        b.classList.remove('is-active');
      });
      this.classList.add('is-active');

      // Find and update variant
      var selectedOptions = getSelectedOptions();
      var variant = findMatchingVariant(selectedOptions);
      if (variant) {
        updateVariant(variant);
      }
    });
  });

  // Handle select changes
  optionSelects.forEach(function(select) {
    select.addEventListener('change', function() {
      var selectedOptions = getSelectedOptions();
      var variant = findMatchingVariant(selectedOptions);
      if (variant) {
        updateVariant(variant);
      }
    });
  });

  // Initialize with current variant state on page load
  function initializeVariantState() {
    // Try to get current variant ID from hidden input
    var currentVariantId = variantIdInput ? parseInt(variantIdInput.value) : null;
    var currentVariant = null;

    // Find current variant in product data
    if (currentVariantId && productData.variants) {
      currentVariant = productData.variants.find(function(v) {
        return v.id === currentVariantId;
      });
    }

    // If not found, try to get from selected options
    if (!currentVariant) {
      var initialOptions = getSelectedOptions();
      currentVariant = findMatchingVariant(initialOptions);
    }

    // If still not found, use first variant
    if (!currentVariant && productData.variants && productData.variants.length > 0) {
      currentVariant = productData.variants[0];
    }

    // Update UI with current variant
    if (currentVariant) {
      updateVariant(currentVariant);
    }
  }

  // Run initialization
  initializeVariantState();
}

// Initialize share button
function initShareButton() {
  var shareBtn = document.querySelector('[data-share-btn]');
  if (!shareBtn) return;

  var popup = buildSharePopup();
  document.body.appendChild(popup);

  shareBtn.addEventListener('click', function(e) {
    e.preventDefault();
    e.stopPropagation();

    if (popup.classList.contains('is-open')) {
      closeSharePopup(popup);
      return;
    }

    positionSharePopup(popup, shareBtn);
    popup.classList.add('is-open');
  });

  document.addEventListener('click', function(e) {
    if (!popup.contains(e.target) && e.target !== shareBtn) {
      closeSharePopup(popup);
    }
  });

  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') closeSharePopup(popup);
  });
}

function buildSharePopup() {
  var url = window.location.href;
  var productTitle = (document.querySelector('.product__title') || {}).textContent || document.title;

  var popup = document.createElement('div');
  popup.className = 'share-popup';
  popup.innerHTML =
    '<div class="share-popup__item" data-share-copy>' +
      '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="9" y="9" width="13" height="13" rx="2"/><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"/></svg>' +
      '<span>Copy Link</span>' +
    '</div>' +
    '<a class="share-popup__item" href="https://wa.me/?text=' + encodeURIComponent(productTitle + ' ' + url) + '" target="_blank" rel="noopener">' +
      '<svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347z"/><path d="M11.5 2C6.261 2 2 6.261 2 11.5c0 1.68.438 3.256 1.204 4.62L2 22l6.047-1.188A9.45 9.45 0 0 0 11.5 21.999C16.739 22 21 17.739 21 12.5S16.739 2 11.5 2zm0 17.5a7.98 7.98 0 0 1-4.074-1.115l-.292-.174-3.589.703.726-3.502-.19-.3A7.95 7.95 0 0 1 3.5 11.5c0-4.41 3.59-8 8-8s8 3.59 8 8-3.59 8-8 8z"/></svg>' +
      '<span>WhatsApp</span>' +
    '</a>';

  popup.querySelector('[data-share-copy]').addEventListener('click', function() {
    var copyBtn = this;
    if (navigator.clipboard) {
      navigator.clipboard.writeText(url).then(function() {
        showCopiedFeedback(copyBtn);
      });
    } else {
      var ta = document.createElement('textarea');
      ta.value = url;
      document.body.appendChild(ta);
      ta.select();
      document.execCommand('copy');
      document.body.removeChild(ta);
      showCopiedFeedback(copyBtn);
    }
  });

  return popup;
}

function showCopiedFeedback(el) {
  var span = el.querySelector('span');
  var original = span.textContent;
  span.textContent = 'Copied!';
  setTimeout(function() {
    span.textContent = original;
    closeSharePopup(el.closest('.share-popup'));
  }, 1500);
}

function positionSharePopup(popup, btn) {
  var rect = btn.getBoundingClientRect();
  var popupW = 160;
  var left = rect.right - popupW;
  if (left < 8) left = 8;
  popup.style.top = (rect.bottom + 8) + 'px';
  popup.style.left = left + 'px';
}

function closeSharePopup(popup) {
  popup.classList.remove('is-open');
}

('=== PRODUCT SCRIPT FILE END ===');
